import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../../Particle";
import Typing from "./Typing";
import Tilt from "react-parallax-tilt";
import AboutmeContainer from "../../components/aboutme/aboutmeContainer";
import Fade from "react-reveal/Fade";

export default function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row className="align-items-center">
            <Col md={7} className="home-header">
              <Fade bottom>
                <h1 className="heading">
                  Hi There!{" "}
                  <span className="wave" role="img" aria-labelledby="wave">
                    👋🏻
                  </span>
                </h1>

                <h1 className="heading-name">
                  I'M <strong className="main-name">SHIVAM TRIPATHI</strong>
                </h1>

                <div className="typing-container mt-4">
                  <Typing />
                </div>
              </Fade>
            </Col>

            <Col md={5} className="d-flex justify-content-center">
              <Fade right>
                <Tilt>
                  <img
                    src="about.png"
                    alt="home pic"
                    className="img-fluid hero-img"
                    style={{ maxHeight: "450px" }}
                  />
                </Tilt>
              </Fade>
            </Col>
          </Row>
        </Container>
      </Container>
      <AboutmeContainer />
    </section>
  );
}
